import PropTypes from 'prop-types';
import { useMemo } from 'react';
// material - use @mui/material so theme has applyStyles (required by MUI 5.18+ Avatar and other components)
import { CssBaseline, ThemeProvider, createTheme, StyledEngineProvider } from '@mui/material';
// Legacy ThemeProvider so notistack receives the same theme
import { ThemeProvider as LegacyThemeProvider } from '@mui/material/styles';
//
import shape from './shape';
import palette from './palette';
import typography from './typography';
import GlobalStyles from './globalStyles';
import ApexChartsGlobalStyles from 'components/charts/ApexChartsGlobalStyles';
import componentsOverride from './overrides';
import shadows, { customShadows } from './shadows';

// ----------------------------------------------------------------------

ThemeConfig.propTypes = {
  children: PropTypes.node
};

export default function ThemeConfig({ children }) {
  const themeOptions = useMemo(
    () => ({
      palette,
      shape,
      typography,
      shadows,
      customShadows
    }),
    []
  );

  const theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <LegacyThemeProvider theme={theme}>
          <CssBaseline />
          <GlobalStyles />
          <ApexChartsGlobalStyles />
          {children}
        </LegacyThemeProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
